module.exports = __webpack_public_path__ + "img/svg/success.195e34dd670727caafe5525dfe8fa2eb.svg";